// extracted by mini-css-extract-plugin
module.exports = {"root":"rule-card_root__IgV_J","icon":"rule-card_icon__Dstne","texts":"rule-card_texts__P2fUG"};